import { DatabaseApplicationType } from '@grouper/modules/database/applicationTypes'
import GridViewRowExpandButtonWithCommentCount from '@grouper_premium/components/row_comments/GridViewRowExpandButtonWithCommentCount'

export class PremiumDatabaseApplicationType extends DatabaseApplicationType {
  getRowExpandButtonComponent() {
    return GridViewRowExpandButtonWithCommentCount
  }
}
